export default __webpack_public_path__ + "static/media/backgroundimg.c7b368c3.png";